import AdSourceHeaderContent from 'components/signUpFunnel/Tempo/AdSourceHeaderContent';
import ImageSection from 'components/signUpFunnel/Tempo/ImageSection';
import useQuery from 'hooks/useQuery';

const TempoHeader = ({ showPartnershipLogo, partnershipLogo, partnershipData }) => {
  const { isQueryParamTrue: isAdSource } = useQuery('source', 'ad');
  const { isQueryParamTrue: isSharapova } = useQuery('ms', 'true');

  return (
    <>
      {isAdSource && (
        <div className="relative">
          <AdSourceHeaderContent
            isSharapova={isSharapova}
            showPartnershipLogo={showPartnershipLogo}
            partnershipLogo={partnershipLogo}
            partnershipData={partnershipData}
          />
          <ImageSection
            variant={isSharapova ? 'sharapova' : 'adSource'}
            partnershipData={partnershipData}
          />
        </div>
      )}
    </>
  );
};

export default TempoHeader;
